// extracted by mini-css-extract-plugin
module.exports = {"root":"CalendarBlock_root__3QBjK"};